export interface Submission {
  _id: string;
  createdAt: Date;
  isApproved: boolean;
  payload: Record<string, any>;
  username: string;
  distId: string;
  type: SubmissionType;
  __v: number;
}

export interface SubmissionUpdate {
  submissionId: String;
  isApproved: boolean;
}

export enum SubmissionType {
  ADD_DEVICE = "add-device",
  REMOVE_DEVICE = "remove-device",
}

export interface UserOnboarding {
  onboard: boolean;
  licenseCount: number;
}
